import { useEffect } from "react";
import { Helmet } from "react-helmet";

import {
  errorMessage,
  m_person_validateEmail,
  useApiMutation,
} from "@mywheels/api";
import { useTranslation } from "@mywheels/common/lib/translation";
import {
  IntParam,
  StringParam,
  useQueryParam,
} from "@mywheels/common/util/useQueryParams";

import { Spinner, useScrollToTop } from "web/ui";
import { ToolbarSpacer } from "web/layout/Toolbar";

export default function ValidateEmailPage() {
  const { t } = useTranslation("page:ValidateEmail");

  const [person = 0] = useQueryParam("person", IntParam);
  const [hash = ""] = useQueryParam("hash", StringParam);

  const { mutate: validate, ...r } = useApiMutation({
    def: m_person_validateEmail,
  });

  useEffect(() => {
    validate({
      person,
      hash,
    });
  }, [validate, person, hash]);

  useScrollToTop();

  return (
    <>
      <Helmet>
        <title>{t("E-mail bevestigen")}</title>
      </Helmet>
      <ToolbarSpacer />
      <div className="mx-auto mt-2 md:mt-10 px-3" style={{ maxWidth: "26rem" }}>
        <div className="shadow bg-white p-6 rounded-md mb-6 flex flex-col items-center">
          {!r.data && <Spinner className="mt-3 mb-4" error={r.error} />}
          {r.data ? (
            <div className="text-center">
              <div className="text-gray700 text-center bg-white p-1 mb-4 font-display text-lg">
                {t("E-mail bevestigd")}
              </div>
            </div>
          ) : r.isLoading ? (
            <div className="text-gray700 text-center bg-white p-1 font-display text-lg">
              {t("E-mail bevestigen...")}
            </div>
          ) : (
            <div className="text-red text-center bg-white p-1 font-display text-lg">
              {t(errorMessage(r.error)) ||
                t(
                  "Er is een onbekende fout opgetreden. Probeer het nog eens, of neem contact met ons op via support@mywheels.nl."
                )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
